import React from 'react'

export default function Login() {
  const handleGoogleLogin = () => {
    window.location.href = '/auth/google_oauth2'
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="flex justify-center">
            <img
              className="h-24 w-auto"
              src="/wv_logo.png"
              alt="Weekend Vans"
            />
          </div>
          <h2 className="mt-6 text-center text-3xl font-bold text-gray-900">
            Weekend Vans Dashboard
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Sign in with your @weekendvans.com Google account
          </p>
        </div>

        <div className="mt-8">
          <button
            onClick={handleGoogleLogin}
            className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-150"
          >
            <span className="absolute left-0 inset-y-0 flex items-center pl-3">
              <svg className="h-5 w-5 text-blue-500 group-hover:text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
              </svg>
            </span>
            Sign in with Google
          </button>
        </div>

        <div className="mt-6">
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300" />
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 bg-gray-50 text-gray-500">
                Authorized users only
              </span>
            </div>
          </div>
        </div>

        <div className="mt-4 text-center text-xs text-gray-500">
          <p>Only @weekendvans.com email addresses are permitted.</p>
          <p className="mt-1">New users require approval from an administrator.</p>
        </div>
      </div>
    </div>
  )
}
